













import Vue from 'vue';
import StatTrends from './StatTrends.vue';
import StatIndicator from './StatIndicator.vue';
import { CustomerRemarkRule } from '../../models/CustomerRemarkRule';

export default Vue.extend({
  components: {
    StatTrends,
    StatIndicator,
  },
  props: {
    ruleId: {
      type: Number,
      default: null,
    },
    type: {
      type: Number,
      default: null,
    },
    slinks: {
      type: Array as () => CustomerRemarkRule[],
      default: [],
    },
  },
  computed: {
    getSlinkId(): number | null {
      const slink = this.slinks.find((slink: any) => {
        return parseInt(slink.sid) === this.ruleId;
      });
      return slink ? (slink as any).id : null;
    },
  },
});
